import { actionTypes, FontList } from './types';

const initialState: FontList = { status: 'not started' };

export default function fontManagement(state = initialState, action): FontList {
    switch (action.type) {
        case actionTypes.GET_FONT_FAMILIES_REQUEST:
            return { status: 'loading', loaded: state.loaded };
        case actionTypes.GET_FONT_FAMILIES_SUCCESS:
            return { status: 'ready', loaded: { families: action.families, loadedAt: action.loadedAt } };
        case actionTypes.GET_FONT_FAMILIES_FAILURE:
            return { status: 'error', errors: action.errors, loaded: state.loaded };
        default:
            return state;
    }
}
